import { render } from "./DocHeaderPage.vue?vue&type=template&id=2f3d0a4c&scoped=true"
import script from "./DocHeaderPage.vue?vue&type=script&lang=js"
export * from "./DocHeaderPage.vue?vue&type=script&lang=js"

import "./DocHeaderPage.vue?vue&type=style&index=0&id=2f3d0a4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3d0a4c"]])

export default __exports__